// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".style_root__3_BxO {\n  width: 43px;\n  height: 43px;\n  background: inherit;\n  border: none;\n  border-radius: 15px;\n  cursor: pointer;\n  margin-left: 10px;\n  display: flex;\n  align-items: center;\n  justify-content: center; }\n\n.style_img__2H_8G {\n  height: 24px; }\n", ""]);
// Exports
exports.locals = {
	"root": "style_root__3_BxO",
	"img": "style_img__2H_8G"
};
module.exports = exports;
